import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const OAuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const code = searchParams.get('code');
    const error = searchParams.get('error');
    const outlook = searchParams.get('outlook'); // NEW: Check for outlook=connected
    
    console.log('[OAuth Callback] Processing OAuth callback...');
    console.log('[OAuth Callback] Code:', code ? 'Present' : 'Missing');
    console.log('[OAuth Callback] Error:', error || 'None');
    console.log('[OAuth Callback] Outlook:', outlook || 'None'); // NEW: Log outlook parameter
    
    // Check if we're in a popup window
    const isPopup = window.opener && window.opener !== window;
    console.log('[OAuth Callback] Is popup:', isPopup);
    
    if (error) {
      console.error('[OAuth Callback] OAuth Error:', error);
      
      if (isPopup) {
        // Send error message to main window and close popup
        try {
          window.opener.postMessage({
            type: 'OAUTH_ERROR',
            error: error
          }, window.location.origin);
          console.log('[OAuth Callback] Error message sent to main window');
          window.close();
        } catch (e) {
          console.error('[OAuth Callback] Failed to communicate with main window:', e);
          // Fallback: redirect in popup
          navigate('/communication?error=oauth_failed');
        }
      } else {
        navigate('/communication?error=oauth_failed');
      }
      return;
    }
    
    // NEW: Handle outlook=connected parameter (from backend redirect)
    if (outlook === 'connected') {
      console.log('[OAuth Callback] OAuth Success - Outlook connected via backend redirect');
      
      if (isPopup) {
        // Send success message to main window and close popup
        try {
          window.opener.postMessage({
            type: 'OAUTH_SUCCESS',
            outlook: 'connected'
          }, window.location.origin);
          console.log('[OAuth Callback] Success message sent to main window');
          
          // Small delay to ensure message is received before closing
          setTimeout(() => {
            window.close();
          }, 100);
        } catch (e) {
          console.error('[OAuth Callback] Failed to communicate with main window:', e);
          // Fallback: redirect in popup
          navigate('/communication?success=oauth_connected');
        }
      } else {
        // Not in popup, redirect normally
        navigate('/communication?success=oauth_connected');
      }
      return;
    }
    
    // EXISTING: Handle code parameter (direct OAuth flow)
    if (code) {
      console.log('[OAuth Callback] OAuth Success - Code received:', code.substring(0, 10) + '...');
      
      if (isPopup) {
        // Send success message to main window and close popup
        try {
          window.opener.postMessage({
            type: 'OAUTH_SUCCESS',
            code: code
          }, window.location.origin);
          console.log('[OAuth Callback] Success message sent to main window');
          
          // Small delay to ensure message is received before closing
          setTimeout(() => {
            window.close();
          }, 100);
        } catch (e) {
          console.error('[OAuth Callback] Failed to communicate with main window:', e);
          // Fallback: redirect in popup
          navigate('/communication?success=oauth_connected');
        }
      } else {
        // Not in popup, redirect normally
        navigate('/communication?success=oauth_connected');
      }
      return;
    }
    
    // No code, outlook, or error
    console.log('[OAuth Callback] No code, outlook, or error - treating as cancelled');
    if (isPopup) {
      try {
        window.opener.postMessage({
          type: 'OAUTH_CANCELLED'
        }, window.location.origin);
        console.log('[OAuth Callback] Cancelled message sent to main window');
        window.close();
      } catch (e) {
        console.error('[OAuth Callback] Failed to communicate with main window:', e);
        navigate('/communication');
      }
    } else {
      navigate('/communication');
    }
  }, [searchParams, navigate]);
  
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Verarbeite Outlook-Authentifizierung...</p>
        <p className="text-sm text-gray-500 mt-2">Dieses Fenster schließt sich automatisch...</p>
      </div>
    </div>
  );
};

export default OAuthCallback;
